import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { WorkflowStepNames, MAX_SUPPORT_TICKET_CHAR_LENGTH } from '../../../constants/constants';
import Routes from '../../../constants/routes';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import TextArea from '../../Common/TextArea';
import Button from '../../Common/Button';
import * as types from '../../../constants/actionTypes';
import './InvalidDefaultLocationWorkflowStep.scss';

class InvalidDefaultLocationWorkflowStep extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoading: false,
            shouldLogout: false,
            isFormValid: true,
            ticketDescription: '',
            ticketSubject: 'Location Access Request',
        };
    }

    onChange = (id) => {
        this.setState({ isLoading: true });
        this.props.userActions
            .setDefaultLocation(id)
            .then((response) => {
                if (response.type == types.SET_DEFAULT_LOCATION_SUCCESS) {
                    Notification('success', 'Success', 'Default Location set successfully');
                    this.props.accountActions.completeWorkflowStep(this.props.step.name);
                } else {
                    Notification('error', 'Error', response.payload.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch((error) => {
                Notification('error', 'Error', error);
                this.setState({ isLoading: false });
            });
    };

    onDescriptionChange = (e) => {
        this.setState({ ticketDescription: e.target.value });
    };

    logout = () => {
        this.setState({ shouldLogout: true });
    };

    onSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            if (!this.state.ticketDescription || this.state.ticketDescription.trim().length <= 0) {
                this.setState({ isFormValid: false });
                return;
            }

            const request = {
                subject: this.state.ticketSubject,
                description: this.state.ticketDescription,
            };
            this.setState({ isLoading: true });
            const response = await this.props.supportActions.createSubscriptionTicket(request);
            if (response.type === types.CREATE_SUBSCRIPTION_TICKET_SUCCESS) {
                Notification('success', 'Success', 'Access Request Support Ticket submitted successfully');
                this.logout();
            } else if (response.type === types.CREATE_SUBSCRIPTION_TICKET_FAILURE) {
                Notification('error', 'Error', response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification('error', 'Error', error);
            this.setState({ isLoading: false });
        }
    };

    render() {
        if (!this.props.user || !this.props.step || this.props.step.name !== WorkflowStepNames.InvalidDefaultLocation) {
            Notification(
                'error',
                'Error',
                'Invalid Step Name: Expected ' + WorkflowStepNames.InvalidDefaultLocation + ' Actual: ' + this.props.step.name
            );
            return <Redirect to={Routes.LoginPage} />;
        }

        if (this.state.shouldLogout) {
            return <Redirect to={Routes.LoginPage} />;
        }

        const valid = this.state.isFormValid ? '' : 'was-validated';
        const className = 'support-form ' + valid;

        return (
            <LoadingIndicator isLoading={this.state.isLoading} isFullscreen={false}>
                <div className='invalid-default-location-workflow-step'>
                    <div className='mb-3' role='alert'>
                        {this.props.step.reason}
                    </div>

                    {this.props.step.locations && this.props.step.locations.length > 0 ? (
                        <div className='text-left'>
                            <MultiSelectBox
                                name='Default Location'
                                placeholder='Select a Default Location'
                                options={this.props.step.locations}
                                idField='id'
                                valueField='name'
                                selectedValues=''
                                onChange={this.onChange}
                                defaultValue='Select a Default Location...'
                                isMulti={false}
                            />
                        </div>
                    ) : (
                        <form className={className} noValidate>
                            <p>Would you like to send a message to your company’s Administrator to gain access?</p>
                            <TextArea
                                name='description'
                                rows={5}
                                placeholder='Question/Comment'
                                onChange={this.onDescriptionChange}
                                maxLength={MAX_SUPPORT_TICKET_CHAR_LENGTH}
                                errorMessage='Question/Comment required'
                                isRequired={true}
                                value={this.state.ticketDescription}
                            />
                            <div className='remaining-chars text-end'>
                                {this.state.ticketDescription.length}/{MAX_SUPPORT_TICKET_CHAR_LENGTH}
                            </div>
                            <div className='button-wrapper'>
                                <Button type='button' onClick={this.logout} text='Logout' bootstrapClass='outline-light' />
                                <Button type='submit' onClick={this.onSubmit} bootstrapClass='outline-primary' text='Submit' />
                            </div>
                        </form>
                    )}
                </div>
            </LoadingIndicator>
        );
    }
}

InvalidDefaultLocationWorkflowStep.propTypes = {
    step: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    supportActions: PropTypes.object.isRequired,
};

export default InvalidDefaultLocationWorkflowStep;
